<template>
  <div class="transportation-route-info p-4 d-flex flex-column align-items-center justify-content-center">

    <h5 class="transportation-route-title font-weight-600">{{ transportationData.title }}</h5>

    <div class="container w-100 p-0">

      <div class="row row-cols-4 align-items-center justify-content-center">
        <div class="col-3 d-flex justify-content-center"><img src="/assets/images/frame-arrow.svg" alt=""></div>
        <div class="col-3">{{ transportationData.pickup_time }}</div>
          <div class="vr vertical-line"></div>
        <div class="col-3 p-2">{{ transportationData.pickup_city.address_to_show }}</div>
      </div>

      <div class="row row-cols-4 align-items-center justify-content-center" v-for="stop in transportationData.transportation_stop" :key="stop.id">
        <div class="col-3 d-flex justify-content-center"><img src="/assets/images/one-dot.svg" alt=""></div>
        <div class="col-3">{{ stop.time }}</div>
          <div class="vr vertical-line"></div>
        <div class="col-3 p-2">{{ stop.transportation_address.address_to_show }}</div>
      </div>

      <div class="row row-cols-4 align-items-center justify-content-center">
        <div class="col-3 d-flex justify-content-center"><img src="/assets/images/frame-flag.svg" alt=""></div>
        <div class="col-3">{{ transportationData.drop_off_time }}</div>
          <div class="vr vertical-line"></div>
        <div class="col-3 p-2">{{ transportationData.dropoff_city.address_to_show }}</div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue";
import type {IApiResponseTransportation} from "../../interfaces/apiResponseInterfaces/IApiResponseTransportation.interface";

export default defineComponent({
  name: "TransportationStopsContainerComponent",

  props: {
    transportationData: {
      type: Object as PropType<IApiResponseTransportation>,
      required: true,
    }
  },

  data() {
    return {
      test: true
    }
  }

})
</script>

<style scoped lang="scss">
@import "./transportationStopsContainer.scss";
</style>